export const PERMISSION_ROLES = {
    BUSINESS_DASHBOARD: 'business-dashboard.read',
    // 查看V5风控报告
    V5_RISK_REPORT: 'v5-risk-report.read',
    V6_RISK_REPORT: 'v6-risk-report.read',
    RISK_REPORT: 'risk-report.read',

    AI_VESSEL_SUMMARY: 'ai.vessel-summary.read',

    // 新增权限常量
    PICC_FLEET_DASHBOARD: 'picc.fleet-dashboard.read',
    PICC_CARGO_REDIRECT: 'picc.cargo-redirect.read',
    // RISK_DASHBOARD: 'risk-dashboard.read',
    RISK_REDUCTION: 'risk-reduction.read',
    // TRACKING: 'tracking.read',
    // DOCUMENT: 'document.read',
    // NEWS: 'news.read',
    // NOTICE: 'notice.read',
    VALUATION_REPORT: 'valuation-report.read',
    BILL: 'bill.read',
    // PLAYBACK: 'playback.read',

    // 帐号管理
    // ACCOUNT: 'account.read',
    ACCOUNT_MANAGEMENT: 'account.management.read',

    // 保险
    INSURE: 'insure.read',
    INSURE_RECOMMEND: 'insure.recommend.read',

    // 助理
    ASSISTANT: 'assistant.read',
    ASSISTANT_CASE_SEARCH: 'assistant.case-search.read',
    ASSISTANT_LAW_FIRM_SEARCH: 'assistant.law-firm-search.read',
    ASSISTANT_SMART_APPRAISAL: 'assistant.smart-appraisal.read',

    // 轨迹导出
    TRAJECTORY_EXPORT: 'trajectory.export.read',

    // 船公司分析tabs
    COMPANY_ANALYSIS_TABS: 'ship-company-analysis-tabs.read',


    INSURE_SHIPYARD_RECOMMEND: 'insure.shipyard-recommend.read',
} as const

export type PermissionRole = typeof PERMISSION_ROLES[keyof typeof PERMISSION_ROLES]
